<script setup>
defineProps({
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: '',
  },
  icon: {
    type: String,
    default: 'i-lucide-inbox',
  },
});
</script>

<template>
  <div class="flex flex-col items-center justify-center py-16 text-center bg-n-solid-2 border border-n-weak rounded-lg">
    <div class="flex items-center justify-center size-16 mb-4 rounded-full bg-n-slate-3 dark:bg-n-slate-4">
      <span :class="icon" class="size-8 text-n-slate-9" />
    </div>
    <h3 class="text-base font-medium text-n-slate-12 mb-1">{{ title }}</h3>
    <p v-if="description" class="text-sm text-n-slate-10 max-w-md mb-6">{{ description }}</p>
    <slot name="action" />
  </div>
</template>
